import { render, staticRenderFns } from "./BCXSortableTableHeader.vue?vue&type=template&id=a0a952ee&scoped=true"
import script from "./BCXSortableTableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXSortableTableHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXSortableTableHeader.vue?vue&type=style&index=0&id=a0a952ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a952ee",
  null
  
)

export default component.exports